import React, { createContext, useContext, useState, useEffect } from "react";
import api from "../utils/api";

const SettingsContext = createContext(null);
const CACHE_KEY = "huwnd_settings_cache";

export function SettingsProvider({ children }) {
  // Initialize immediately from localStorage – eliminates hero/logo flash on reload
  const [settings, setSettings] = useState(() => {
    try {
      const cached = localStorage.getItem(CACHE_KEY);
      return cached ? JSON.parse(cached) : null;
    } catch {
      return null;
    }
  });
  const [loading, setLoading] = useState(true);

  const applySettings = (data) => {
    setSettings(data);
    try { localStorage.setItem(CACHE_KEY, JSON.stringify(data)); } catch {}
  };

  useEffect(() => {
    api.get("/settings/")
      .then(r => applySettings(r.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const refresh = () => {
    api.get("/settings/").then(r => applySettings(r.data)).catch(() => {});
  };

  return (
    <SettingsContext.Provider value={{ settings, setSettings: applySettings, refresh, loading }}>
      {children}
    </SettingsContext.Provider>
  );
}

export function useSettings() {
  return useContext(SettingsContext);
}
